import { View } from "react-native";
import { Text } from "@shared/components/text";
import { LockIcon } from "@shared/components/md-design-system/Icon/ActivityIcon";
import { colorPalette } from "@shared/config/colorsConfig";
import { HOME_CARD } from "../../../constants";
import { ActivityIconBox } from "./ActivityIconBox";

interface IActivityLaterCardProps {
    activityType: string;
    activityName: string;
    title: string;
    whenText?: string;
    unlockLabel: string;
}

export const ActivityLaterCard = ({
    activityType,
    activityName,
    title,
    whenText,
    unlockLabel,
}: IActivityLaterCardProps) => (
    <View className="flex-row items-start bg-white gap-4 rounded-2xl px-6 py-4 border-2 border-dashed border-gray-400">
        <View className="self-center">
            <ActivityIconBox
                activityType={activityType}
                activityName={activityName}
                size={HOME_CARD.iconBox}
                glyphSize={HOME_CARD.iconGlyph}
                color={colorPalette.gray[500]}
            />
        </View>

        <View className="flex-1">
            <Text className="font-bold text-base text-gray-500" numberOfLines={2}>{title}</Text>
            {!!whenText && (
                <Text className="text-md text-gray-500 mt-1.5">{whenText}</Text>
            )}
        </View>

        <View className="flex-row items-center self-start gap-[9px] mt-[5px]">
            <LockIcon size={19} color={colorPalette.gray[500]} />
            <Text className="text-md font-semibold text-gray-500">{unlockLabel}</Text>
        </View>
    </View>
);

export default ActivityLaterCard;
